import React from 'react'
import styled from 'styled-components'
import {
  Link,
  Text,
  Heading,
  Box,
  Container,
  Button,
  Image,
  getPaletteColor
} from 'pcln-design-system'
import {
  useContentful,
  getVariantContent,
  ContentfulRichText,
  ToutType,
  VariationCollectionType
} from '@pcln/contentful-components'
import content from './content'
import useSeti from '../CustomHooks/useSeti'
import isContentVariationCollectionType from '../../utils/is-content-variantion-collection-type'

const StyledText = styled(Text)`
  list-style-position: inside;
  & li {
    margin: 4px 0;
  }
`

const StyledContentfulRichText = styled(ContentfulRichText)`
  list-style-position: inside;
  & p {
    display: inline;
  }
`

const StyledLink = styled(Link)`
  display: flex;
`
const StyledBox = styled(Box)`
  border-bottom: 1px solid;
  border-color: ${getPaletteColor('border.base')};
`

function mapContentfulContent(promo: ToutType) {
  const { url, label } = promo.callsToAction?.[0] ?? {}
  const desktopFocalPoint = promo.image?.desktopFocalPoint ?? 'center'

  return {
    titleText: promo.headline,
    bodyText: promo.body,
    buttonText: label,
    image: promo.image
      ? `${promo.image.asset?.file.url}?w=380&h=240&f=${desktopFocalPoint}&fit=fill`
      : '',
    imageAlt: promo.image?.altText,
    legalText: promo.disclaimer,
    buttonLink: url
  }
}

export default function CreditCard() {
  const barclaysPromoFromContentful = useContentful('creditCardPromo') as
    | ToutType
    | VariationCollectionType
    | undefined

  const isVariantCollection = isContentVariationCollectionType<ToutType>(
    barclaysPromoFromContentful
  )

  const setiName = useSeti(
    isVariantCollection ? barclaysPromoFromContentful.experimentName : ''
  )
  const promo = isVariantCollection
    ? (getVariantContent(setiName, barclaysPromoFromContentful) as
        | ToutType
        | undefined)
    : barclaysPromoFromContentful

  const {
    titleText,
    bodyText,
    buttonText,
    image,
    imageAlt,
    legalText,
    buttonLink
  } = promo ? mapContentfulContent(promo as ToutType) : content
  return (
    <StyledBox py={5} color="background.lightest">
      <Container maxWidth={1280}>
        <Box textAlign="center" mb={4}>
          <Heading fontWeight="bold" fontSize={4} mb={3} color="text">
            {titleText}
          </Heading>
          {barclaysPromoFromContentful ? (
            <Text fontSize={[2, 3]} mb={3}>
              <StyledContentfulRichText color="text.light" body={bodyText} />
            </Text>
          ) : (
            <StyledText fontSize={[2, 3]} color="text.light" mb={3}>
              {bodyText}
            </StyledText>
          )}

          <Link href={buttonLink}>
            <Button px={5} data-testid="CREDIT_CARD_BUTTON">
              {buttonText}
            </Button>
          </Link>
        </Box>
        {image && (
          <Box mb={4}>
            <StyledLink href={buttonLink}>
              <Image
                src={
                  barclaysPromoFromContentful
                    ? image
                    : `${image}?opto&auto=webp`
                }
                width="380px"
                height="240px"
                alt={imageAlt}
                m="auto"
                loading="lazy"
              />
            </StyledLink>
          </Box>
        )}
        {barclaysPromoFromContentful ? (
          <Box textAlign="center" mb={3}>
            <ContentfulRichText
              fontSize={1}
              color="text.light"
              body={legalText}
            />
          </Box>
        ) : (
          <Text textAlign="center" fontSize={1} color="text.light" mb={3}>
            {legalText}
          </Text>
        )}
      </Container>
    </StyledBox>
  )
}
